import styled from 'styled-components';

export const AccordionContainer = styled.div`

    @media only screen and (max-width: 600px){
        padding: 0 1em;
        box-sizing: border-box;
    }
`;